module.exports = __webpack_public_path__ + "img/電気回路_4_6_2.6138e8c1.png";